module.exports = __webpack_public_path__ + "static/media/05-news-detail.91948e96.png";